import { render } from "./Cooldown.vue?vue&type=template&id=5ddfdf9d&scoped=true"
import script from "./Cooldown.vue?vue&type=script&lang=js"
export * from "./Cooldown.vue?vue&type=script&lang=js"

import "./Cooldown.vue?vue&type=style&index=0&id=5ddfdf9d&scoped=true&lang=css"

import exportComponent from "/Users/warths/refonte-manager-cli/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ddfdf9d"]])

export default __exports__